// extracted by mini-css-extract-plugin
export default {"root":"qp1Y6Qj30pzRKVxX7xaA","turbo":"gkweozuGZHVJngFBvGRT","money":"_5d3vVD3LDukSClatV4C","date":"w5i43OfK0p4ab3PzfatP"};